import { render } from "./MainContentWrapper.vue?vue&type=template&id=1b90b659&scoped=true"
import script from "./MainContentWrapper.vue?vue&type=script&lang=js"
export * from "./MainContentWrapper.vue?vue&type=script&lang=js"

import "./MainContentWrapper.vue?vue&type=style&index=0&id=1b90b659&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b90b659"]])

export default __exports__